import { ActionType, createReducer } from 'typesafe-actions';

import * as actions from './orders.actions';
import { initialState } from './orders.initialState';
import { mapSpotOrderUpdateFromSocket } from './orders.mapper';

type State = typeof initialState;
type Actions = ActionType<typeof actions>;

export const ordersReducer = createReducer<State, Actions>(initialState)
  .handleAction(actions.actionGetCustomerOrders, (state) => ({
    ...state,
    loading: state.init,
  }))
  .handleAction(actions.actionSuccessCustomerOrders, (state, action) => ({
    ...state,
    loading: false,
    init: false,
    orders: action.payload.data,
  }))
  .handleAction(actions.actionErrorCustomerOrders, (state) => ({
    ...state,
    error: true,
    loading: false,
  }))
  .handleAction(actions.actionSignalrOrderUpdatedSuccess, (state, action) => ({
    ...state,
    orders: mapSpotOrderUpdateFromSocket(state.orders || [], action.payload),
  }))
  .handleAction(actions.actionGetCustomerTrades, (state) => ({
    ...state,
    loading: true,
  }))
  .handleAction(actions.actionSuccessCustomerTrades, (state, action) => ({
    ...state,
    trades: action.payload.data,
    latestTrade: action.payload.data?.[0] ?? null,
    loading: false,
  }))
  .handleAction(actions.actionSuccessLatestTrade, (state, action) => ({
    ...state,
    latestTrade: action.payload ?? null,
  }))
  .handleAction(actions.actionSetOrderIDIsEditing, (state, action) => ({
    ...state,
    orderIdIsEditing: action.payload,
  }))
  .handleAction(actions.actionErrorCustomerTrades, (state) => ({
    ...state,
    error: true,
  }));
